import React, { useEffect, useState, useRef } from 'react'

interface Props {
  className?: string
  style?: object
  name: string
}

const Icon: React.FC<Props> = ({ className, name, style }) => {
  const [icon, setIcon] = useState('')
  const mounted = useRef(false)

  useEffect(() => {
    mounted.current = true

    return () => {
      mounted.current = false
    }
  }, [])

  useEffect(() => {
    import(`./${name}.svg`).then(icon => {
      if (mounted.current) {
        setIcon(icon.default)
      }
    })
  }, [name])

  if (icon === '') {
    return null
  }

  return (
    <img
      className={className}
      alt=""
      src={icon}
      style={{
        verticalAlign: 'middle',
        ...style,
      }}
    />
  )
}

export default Icon
